<template>
    <div v-if="minutos"> 
            <v-icon color="success"  class="pa-1">fa-clock</v-icon>
            <v-chip class="ml-1" small label color="#0D1011D3" text-color="white"><strong>{{cuentaRegresiva ? cuentaRegresiva.format('HH') : '00'}}</strong></v-chip>
            <v-chip class="ml-1" small label color="#0D1011D3" text-color="white"><strong>{{cuentaRegresiva ? cuentaRegresiva.format('mm') : '00'}}</strong></v-chip>
            <v-chip class="ml-1" small label color="#0D1011D3" text-color="white"><strong>{{cuentaRegresiva ? cuentaRegresiva.format('ss') : '00'}}</strong></v-chip>
    </div>
</template>

<script>
    import  moment from 'moment';
    export default {
        name: 'RelojRegresivo',
        props: {
            id : {
                type: Number,
                required: false
            },
            minutos: {
                type: String,
                required: true
            },
            estado:{
                type: Boolean,
                required: true
            }
        },
        data () {
            return {
                cuentaRegresiva: null,
                expiraEn: null,
                intervalo: null,
            }
        },
        watch:{
            estado(e){
               if (e) {
                this.EstablecerIntervalo();
               }
            },
            // expiraEn(e){
            //     console.log(e);
            // }
        },
        mounted () {
        
            this.EstablecerIntervalo();
        },
        beforeDestroy() {
            // Limpia el intervalo cuando el componente se destruye
            this.LimpiarIntervalo();
        },
        methods: {
            LimpiarIntervalo: function() {
                if (this.intervalo) {
                    clearInterval(this.intervalo);
                    this.intervalo = null;
                }
            },
            EstablecerIntervalo: function() {
                 // Limpiar cualquier intervalo existente antes de establecer uno nuevo
                this.LimpiarIntervalo();

                this.cuentaRegresiva = null;

                const [horas, minutos, segundos] = this.minutos.split(':').map(Number);
                const totalSegundos = horas * 3600 + minutos * 60 + segundos;

                this.expiraEn = totalSegundos;

                this.intervalo = setInterval(() => {
                    if (this.expiraEn === 0) {
                        clearInterval(this.intervalo);

                        console.log('this.id',this.id);

                        this.$emit("expirado", this.id);
                    } else {
                        this.expiraEn -= 1;
                        if(this.expiraEn === 0){
                            this.cuentaRegresiva = null;
                        } else {
                            this.cuentaRegresiva = moment.utc(this.expiraEn * 1000).subtract(1, 'seconds');
                        }                            
                    }
                }, 1000);
            },
        }
    }
</script>